import styled from 'styled-components'

const MenuEditorItemLabel = styled.div`
  flex: 1;

  input, select {
    border: none !important;
    outline: none !important;
    border-radius: none !important;
    color: black;
    box-shadow: none !important;
    padding: 0 !important;
    background: transparent !important;
  }
`

export default MenuEditorItemLabel